import * as React from 'react';

import styles from './map.css';
import { EMapTypes } from '../../../constants/map';
import { VillageMap } from '../../map';
import { MapType } from '../../map/MapType';
import { ZoomControls } from '../../map/zoom';

export class Map extends VillageMap {
  protected minZoom = 0;

  public render() {
    const { coordinates, mapType } = this.props;
    const nextViewType = mapType === EMapTypes.satellite ? EMapTypes.map : EMapTypes.satellite;

    return (
      <div className={styles['container']}>
        <div
          ref={ref => {
            this.mapContainer = ref;
          }}
          className={styles['map']}
        />
        <ZoomControls
          onZoomIn={this.onZoom('in')}
          onZoomOut={this.onZoom('out')}
          disabledZoomIn={this.disabledZoomIn()}
          disabledZoomOut={this.disabledZoomOut()}
          centred
        />
        {this.shouldUseSatelliteMap() && (
          <MapType
            mapType={mapType}
            coordinates={coordinates}
            onChange={() => this.handlerClickMapTypeButton(nextViewType)}
          />
        )}
      </div>
    );
  }
}
